import { gql } from "@apollo/client";

export const CREATE_MAILBOX = gql`
  mutation CreateMailboxMutation($input: CreateMailboxInput!) {
    createMailbox(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_MAILBOX = gql`
  mutation UpdateMailboxMutation($id: Int!, $input: UpdateMailboxInput!) {
    updateMailbox(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_MAILBOX = gql`
  mutation RemoveMailboxMutation($id: Int!) {
    removeMailbox(id: $id) {
      ok
      error
    }
  }
`;

export const MY_MAILBOX = gql`
  query MyMailboxQuery {
    myMailbox {
      ok
      error
      result {
        id
        email
        imapHost
        imapPort
        smtpHost
        smtpPort
        lastSyncedAt
        active
      }
    }
  }
`;
